import {
    LIST_OF_LANDING,IS_LOADING_LANDINGS,DATA_OF_LANDING,DELETE_LANDING,DEFAULT_LANDING,IS_LOADING_POINT_PACKAGES,DELETE_POINT_PACKAGE,GET_POINT_PACKAGE_INFO,
    LIST_OF_POINT_PACKAGES,EDIT_TYPE_OF_LANDING,CREATE_TYPE_OF_LANDING,CREATE_POINT_PACKAGE,EDIT_POINT_PACKAGE

    } from '../actions/types'
    
    const initialState = {
        isLoadingLandings:false,
        landingList:[],
        landingData:{},
        defaultLanding:{},
        isLoadingListPointPackages:false,
        listPointPackages:[],
        pointPackageInfo:{}
    }
    
    export default function (state = initialState, action) {
        switch (action.type) {
    
            case LIST_OF_LANDING:
                return { ...state, landingList:action.payload, isLoadingLandings:false}
            case IS_LOADING_LANDINGS:
                return { ...state, isLoadingLandings:true}
            case CREATE_TYPE_OF_LANDING:
                var addTypeOfLanding = state.landingList
                addTypeOfLanding.push(action.payload)
                return { ...state, landingList: addTypeOfLanding, isLoadingLandings: false }
            case EDIT_TYPE_OF_LANDING:
                var editTypeOfLanding = state.landingList
                editTypeOfLanding[action.payload.index] = action.payload.data
                return { ...state, landingList: editTypeOfLanding, isLoadingLandings: false }
            case DATA_OF_LANDING:
                return { ...state, landingData:action.payload}
            case DELETE_LANDING:
                var deleteLanding = state.landingList
                deleteLanding.splice(action.payload, 1)            
                return { ...state, isLoadingLandings:false, landingList:deleteLanding}
            case DEFAULT_LANDING:
                return { ...state, defaultLanding:action.payload}

            case IS_LOADING_POINT_PACKAGES:
                return { ...state, isLoadingListPointPackages:true}
            case CREATE_POINT_PACKAGE:
                var addPointPackage = Array.from(state.listPointPackages)
                addPointPackage.push(action.payload)
                return { ...state, listPointPackages: addPointPackage, isLoadingListPointPackages: false }
            case EDIT_POINT_PACKAGE:
                var editTypeOfLanding = Array.from(state.listPointPackages)
                editTypeOfLanding[action.payload.index] = action.payload.data
                return { ...state, listPointPackages: editTypeOfLanding, isLoadingListPointPackages: false }
            case LIST_OF_POINT_PACKAGES:
                return { ...state, listPointPackages:action.payload, isLoadingListPointPackages:false}
            case DELETE_POINT_PACKAGE:
                var deletePointPackage = Array.from(state.listPointPackages)
                deletePointPackage.splice(action.payload, 1)            
                return { ...state, isLoadingListPointPackages:false, listPointPackages:deletePointPackage}
            case GET_POINT_PACKAGE_INFO:
                return { ...state, pointPackageInfo:action.payload}
            default:
                return state
            
        }
    }